/** Increment whenever a client/server wire shape becomes incompatible. */
export const PROTOCOL_VERSION = 17;

export const PROTOCOL_HEADER = 'x-nightshift-protocol-version';
